import { render } from "./InstructionsBlock.vue?vue&type=template&id=e0990b0a"
import script from "./InstructionsBlock.vue?vue&type=script&lang=js"
export * from "./InstructionsBlock.vue?vue&type=script&lang=js"
script.render = render

export default script